
































import Vue from 'vue';
import { EventBus } from '@/event-bus';
import distributionReason from './help-tray-templates/distribution-reason.help.vue';
import { getContentArea } from '@/contentful';

interface Data {
  visible: boolean;
  template: string;
  content: string;
  loading: boolean;
}

export default Vue.extend({
  name: 'HelpTrayWrapper',
  data(): Data {
    return {
      visible: false,
      template: null,
      content: null,
      loading: true,
    };
  },
  mounted() {
    EventBus.$on('openHelp', (template) => {
      setTimeout(() => {
        this.openHelp(template);
      }, 0);
    }).$on('closeHelp', () => {
      this.closeHelp();
    });
  },
  methods: {
    openHelp(template): void {
      this.visible = true;
      EventBus.$emit('openNavTray');
      getContentArea(template).then((data) => {
        this.content = data.fields;
        this.loading = false;
      });
      setTimeout(() => {
        (this.$refs.closeButton as any).$el.focus();
      }, 250);
    },
    closeHelp(): void {
      this.visible = false;
      this.template = null;
      EventBus.$emit('closeNavTray');
    },
  },
  components: {
    distributionReason,
  },
});
